import { NotifyHelper } from '../../../helpers/toast';
import { eLegalDocumentDefine } from '../../action-types/legal-document/ILegalDocumentActionTypes';
import { generateActionForKey, generateActions } from '../generateActions';
export const legalDocumentActions = {
    ...generateActions(eLegalDocumentDefine, "LEGAL_DOCUMENT"),
    ...generateActionForKey(eLegalDocumentDefine, "LEGAL_DOCUMENT", "LOAD_ERROR", (m) => { NotifyHelper.Error(m) }),
    ...generateActionForKey(eLegalDocumentDefine, "LEGAL_DOCUMENT", "DELETE_ERROR", (m) => { NotifyHelper.Error(m) }),
    ...generateActionForKey(eLegalDocumentDefine, "LEGAL_DOCUMENT", "SAVE_ERROR", (m) => { NotifyHelper.Error(m) }),
    ...generateActionForKey(eLegalDocumentDefine, "LEGAL_DOCUMENT", "DELETE_SUCESSS", () => { NotifyHelper.Success("Deleted!") }),
    ...generateActionForKey(eLegalDocumentDefine, "LEGAL_DOCUMENT", "SAVE_SUCESSS", () => { NotifyHelper.Success("Saved!") }),
}